<template>
	<v-container grid-list-xl>
			<v-layout row wrap>
				<v-flex lg12>
          <v-flex xs3 style="padding-left:0px !important;">
            <v-text-field append-icon="search" label="Search" solo single-line v-model="search"></v-text-field><br />
          </v-flex>
          <v-data-table style="margin-top: 0px;" :search="search" :headers="headers" :items="soPopupReps" hide-actions class="elevation-1 repLinkTable" disable-initial-sort :rows-per-page-items="[20,40,60,80,100]">
            <template slot="items" slot-scope="props">
              <!--<td width="15%">{{ props.item.checked }}<v-switch @change="fncSaveResponsibleRep( props.item )" v-model="props.item.checked"></v-switch></td>-->
              <td width="15%"><v-switch @change="fncSaveResponsibleRep( props.item )" v-model="props.item.checked"></v-switch></td>
              <td width="45%">{{ props.item.userName }} {{ props.item.surname }}</td>
              <td width="40%">{{ props.item.name }}</td>
            </template>
          </v-data-table>
				</v-flex>
        <div class="pl-4 pr-1 pb-2 pt-2 buttonHolder" style="margin-top: 0px !important;">
          <div style="float: right">
            <v-btn class="text-xs-right cancelButton" @click.stop="fncHideModal">Close</v-btn>
            <!--<v-progress-circular indeterminate :width="3" :size="20" v-if="runAdd" color="grey" class="pt-3 loginLoader"></v-progress-circular>
            <v-btn color="success" class="text-xs-right" v-if="!runAdd" :disabled="!isAddValid" @click.stop="fncAddStatus()">Save</v-btn>-->
          </div>
        </div>
</v-layout>

	</v-container>
</template>

<script>
	import { mapGetters } from 'vuex';
	import Swatches from 'vue-swatches';
	import "vue-swatches/dist/vue-swatches.min.css";

	export default {
	  name: 'Settings',
	  components: { Swatches },
	  data () {
			return {
			  soPopupReps: [],
			  search: '',
			  loading: true,
        filterRole: 0,
			  responsibleReps: [],
        headers: [
          { text: '', value: '', width: '15%' },
          { text: 'User', value: 'name', width: '45%' },
          { text: 'Role', value: 'name', width: '40%' }
        ],
			};
		},
		methods: {
      canShowRow( item ) {
        if( parseInt(this.filterRole) == 0 ) {
          return true;
        } else {
          var rowId = this.fncExtractData(item, 2);
          if( parseInt(this.filterRole) == parseInt(rowId) ) {
            return true;
          } else {
            return false;
          }
        }
        return false;
      },
      fncExtractData( data, index ) {
        var splitData = data.split('|');
        return splitData[index];
      },
      fncSaveResponsibleRep( row ) {

        var newSoReps = [];
        for( var r in this.soPopupReps ) {
          if( this.soPopupReps[r].checked == true ) {
            newSoReps.push( this.soPopupReps[r] );
          }
        }
        for( var r in this.soPopupReps ) {
          if( this.soPopupReps[r].checked == false ) {
            newSoReps.push( this.soPopupReps[r] );
          }
        }
        this.soPopupReps = newSoReps;

        this.$store.dispatch({
          type: 'fncUpdateQuoteRepsSwitchSo',
          id: this.globalModalParams.quoteId,
          reps: this.soPopupReps
        })

      },
      fncHideModal () {
        this.$store.commit('hideModal');
        window.location.reload();
      }
		},
    beforeMount() {

      this.$store.dispatch({
        type: 'fncGetResponsibleReps',
        quote: this.globalModalParams.quoteId
      });

    },
    mounted() {

	    /*var modalParams = this.globalModalParams;
      var mountedThis = this;

      this.filterRole = modalParams.roleId;*/

	    /*setTimeout(function() {
	      console.log('LIST');
	      console.log( modalParams.object.responsible_user_list );
        for( var r in modalParams.object.responsible_user_list ) {
          var isChecked = false;
          if( modalParams.object.new_responsible_reps_ids_obj && modalParams.object.new_responsible_reps_ids_obj.indexOf(r) != -1 ) {
            isChecked = true;
          }
          if( isChecked == true ) {
            mountedThis.responsibleReps.push({ id: r, name: modalParams.object.responsible_user_list[r], checked: isChecked });
          }
        }
        for( var r in modalParams.object.responsible_user_list ) {
          var isChecked = false;
          if( modalParams.object.new_responsible_reps_ids_obj && modalParams.object.new_responsible_reps_ids_obj.indexOf(r) != -1 ) {
            isChecked = true;
          }
          if( isChecked == false ) {
            mountedThis.responsibleReps.push({ id: r, name: modalParams.object.responsible_user_list[r], checked: isChecked });
          }
        }

        mountedThis.loading = false;
      }, 1000)*/

    },
		computed: {
			...mapGetters([
				'objAuthorize',
				'globalModalParams',
        'soReps'
			])
		},
		watch: {
	    soReps() {
        if( typeof(this.soReps) == 'object' ) {
          for( var u in this.globalModalParams.users ) {
            var subRep = this.globalModalParams.users[u];
            if( this.soReps.indexOf( parseInt(subRep.id) ) != -1 ) {
              subRep.checked = true;
              this.soPopupReps.push( subRep );
            }
          }
          for( var u in this.globalModalParams.users ) {
            var subRep = this.globalModalParams.users[u];
            if( this.soReps.indexOf( parseInt(subRep.id) ) == -1 ) {
              subRep.checked = false;
              this.soPopupReps.push( subRep );
            }
          }
        }
      }
    }
	}
</script>

<style scoped>
	/*@import '../../assets/css/shared.css'*/
</style>
